import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';
import usePartnerNextUp from '#client/hooks/partnerDash/usePartnerNextUp';

import { PartnerNextUpCard } from './components/PartnerNextUpCard';
import * as Styled from './PartnerNextUp.style';

function PartnerNextUp() {
  const { formatMessage } = useIntl();
  const { cards, loading } = usePartnerNextUp();

  if (!loading && cards.length === 0) {
    return null;
  }

  return (
    <HomeSection
      title={(
        <Text size="xl" weight="medium" loading={loading}>
          {!loading && <FormattedMessage id="dashboard.partnerNextUp.title" />}
        </Text>
      )}
    >
      {loading ? (
        <Skeleton data-testid="partner-next-up-skeleton" height={300} />
      ) : (
        <Styled.CardList component="ul">
          {cards.map((card, idx) => (
            <Styled.CardItem
              component="li"
              key={card.type}
            >
              <PartnerNextUpCard
                ctaType={card.ctaType}
                ctaUrl={card.ctaUrl}
                description={formatMessage({ id: card.descriptionId })}
                estimate={card.estimate}
                highlight={cards.length > 1 && idx === 0}
                imageUrl={card.imageUrl}
                isLocked={card.isLocked}
                title={formatMessage({ id: card.titleId })}
              />
            </Styled.CardItem>
          ))}
        </Styled.CardList>
      )}
    </HomeSection>
  );
}

export default PartnerNextUp;
